import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Cabeçalho padrão das telas administrativas (dark navy — padrão TÔ INDO ALI).
 *
 * Uso:
 *   <AdminPageHeader
 *     title="Documentos de Menores"
 *     description="Fila de análise dos documentos enviados pelos titulares"
 *     Icon={FileText}
 *     actions={<Button>Nova ação</Button>}
 *   />
 */
export const AdminPageHeader = ({
  title,
  description,
  Icon,
  // Mantido para compatibilidade com telas existentes; não é mais usado,
  // pois no header navy o ícone fica branco.
  iconClassName,
  actions,
  backTo = '/admin',
  testId,
}) => {
  const navigate = useNavigate();
  return (
    <header
      className="bg-[#003366] text-white shadow-lg sticky top-0 z-20"
      data-testid={testId || 'admin-page-header'}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-3 flex-wrap">
        <button
          type="button"
          onClick={() => navigate(backTo)}
          className="flex items-center gap-1 text-white/90 hover:text-[#FFD700] transition-colors text-sm font-medium"
          data-testid="admin-page-back"
        >
          <ArrowLeft className="w-5 h-5" />
          Voltar
        </button>
        <div className="flex-1 min-w-0 flex items-center gap-3">
          {Icon && <Icon className="w-6 h-6 text-white shrink-0" />}
          <div className="min-w-0">
            <h1 className="text-xl font-bold truncate">{title}</h1>
            {description && (
              <p className="text-xs text-white/70 mt-0.5 truncate">{description}</p>
            )}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
    </header>
  );
};

/**
 * Wrapper padrão de container de página admin.
 */
export const AdminPageShell = ({ children }) => (
  <div className="min-h-screen bg-gray-50 pb-12">{children}</div>
);

export const AdminPageBody = ({ children, className = '' }) => (
  <div className={`max-w-7xl mx-auto px-4 py-6 space-y-4 ${className}`}>{children}</div>
);

export default AdminPageHeader;
